import { lazy } from 'react';
const ExitRequestApproval = lazy(() => import('./ExitRequestApproval'));

const ExitRequestApprovalRoutes = [
  {
    path: '/exitrequestapproval',
    component: ExitRequestApproval
  }
];

export default ExitRequestApprovalRoutes;
